import { Link } from "react-router-dom";
import ImmovoxLogo from "@/components/ImmovoxLogo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-foreground text-background">
      <div className="mx-auto max-w-[1440px] px-5 py-14 md:px-8 md:py-16 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <ImmovoxLogo size={28} className="text-background" />
              <span className="text-xl font-semibold tracking-[-0.04em]">Immovox</span>
            </div>
            <p className="mt-5 max-w-[320px] text-sm leading-6 text-background/58">
              L'IA téléphonique conçue pour les agences immobilières. Chaque appel pris, qualifié, prêt à traiter.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4 lg:col-span-8">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-background/40">Produit</p>
              <div className="mt-4 flex flex-col gap-2.5 text-sm">
                <Link to="/fonctionnalites" className="text-background/65 hover:text-background">Fonctionnalités</Link>
                <Link to="/cas-dusage" className="text-background/65 hover:text-background">Cas d'usage</Link>
                <Link to="/tarifs" className="text-background/65 hover:text-background">Tarifs</Link>
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-background/40">Expertise</p>
              <div className="mt-4 flex flex-col gap-2.5 text-sm">
                <Link to="/standard-telephonique-immobilier" className="text-background/65 hover:text-background">Standard immobilier</Link>
                <Link to="/permanence-telephonique-immobilier" className="text-background/65 hover:text-background">Permanence</Link>
                <Link to="/qualification-appels-immobilier" className="text-background/65 hover:text-background">Qualification</Link>
                <Link to="/appels-manques-agence-immobiliere" className="text-background/65 hover:text-background">Appels manqués</Link>
                <Link to="/accueil-telephonique-immobilier" className="text-background/65 hover:text-background">Accueil téléphonique</Link>
                <Link to="/telephonie-agence-immobiliere" className="text-background/65 hover:text-background">Téléphonie d'agence</Link>
                <Link to="/agent-vocal-ia-immobilier" className="text-background/65 hover:text-background">Agent vocal IA</Link>
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-background/40">Immovox</p>
              <div className="mt-4 flex flex-col gap-2.5 text-sm">
                <Link to="/blog" className="text-background/65 hover:text-background">Ressources</Link>
                <Link to="/a-propos" className="text-background/65 hover:text-background">À propos</Link>
                <Link to="/contact" className="text-background/65 hover:text-background">Contact</Link>
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-background/40">Légal</p>
              <div className="mt-4 flex flex-col gap-2.5 text-sm">
                <Link to="/mentions-legales" className="text-background/65 hover:text-background">Mentions légales</Link>
                <Link to="/cgu" className="text-background/65 hover:text-background">CGU</Link>
                <Link to="/confidentialite" className="text-background/65 hover:text-background">Confidentialité</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-background/12 pt-6 text-xs text-background/38 sm:flex-row sm:items-center sm:justify-between">
          <span>© {currentYear} Immovox</span>
          <a href="mailto:contact@immovox.fr" className="hover:text-background">contact@immovox.fr</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
